import { useTranslation } from 'react-i18next';
import { uniqBy } from 'tools';

import { DefineFilters, useIsMobile } from '@tq/ui-components';
import { Document } from 'types';

export const useDocumentFilters = (
  documents: Document[] | undefined,
  isDocuments: boolean
): DefineFilters[] => {
  const { t } = useTranslation('case_details_documents');

  const isMobile = useIsMobile();

  return [
    {
      type: 'search',
      SearchInputProps: {
        placeholder: t('search_plans', 'Search documents'),
        'aria-label': t(
          'search_screen_reader_help',
          'Search documents. Document list will be filtered when you input text.'
        ),
      },
    },
    {
      type: 'group',
      filtersInGroup: [
        {
          type: 'filter',
          controlLabel: `${t('document_type', 'Document type')}:`,
          filterModalHeader: isDocuments
            ? t('documents_filter', 'Documents filter')
            : t('plans_filter', 'Plans filter'),
          filterOptions: [
            {
              column: 'documentType',
              label: t('all', 'All'),
            },
            ...uniqBy(documents ?? [], (doc) => doc.documentType).map((doc) => ({
              column: 'documentType',
              value: doc.documentType,
              label: doc.documentType,
            })),
          ],
        },
        {
          type: 'sort',
          controlLabel: `${isMobile ? t('sort', 'Sort') : t('sort_by', 'Sort by')}:`,
          groupSortOptions: [
            {
              label: t('date_published', 'Date published'),
              options: [
                {
                  column: 'datePublished',
                  label: t('date_published_newest', 'Newest'),
                  desc: true,
                },
                {
                  column: 'datePublished',
                  label: t('date_published_oldest', 'Oldest'),
                  desc: false,
                },
              ],
            },
            {
              label: t('document_type', 'Document type'),
              options: [
                {
                  column: 'documentType',
                  label: t('document_type_a_to_z', 'A to Z'),
                  desc: false,
                },
                {
                  column: 'documentType',
                  label: t('document_type_z_to_a', 'Z to A'),
                  desc: true,
                },
              ],
            },
          ],
        },
      ],
    },
  ];
};
